import * as api from '.';
import { productGuideURL, productSearchURL, searchURL } from '../config/SearchAPIConfig';
import type { PaginationType } from '../model/types';
import type { ProductCardDetails } from '../product/ProductCard';
import type { SortValue } from '../sortSelector/SortSelector';
import { catchUnauthorizedAndRetry } from '../utils/catchAndRetry';

export interface QueryValue {
    query: {
        value: string;
    };
}

export interface BreadcrumbResponse {
    facetCode: string;
    facetName: string;
    facetValueCode: string;
    facetValueName: string;
    removeQuery: QueryValue;
}

export interface ProductSearchResponse {
    pagination: PaginationType;
    broadcastMessage: string;
    searchPageInfo: string;
    products: ProductCardDetails[];
    facets: FacetResponse[];
    freeTextSearch: string;
    currentQuery: QueryValue;
    spellingSuggestion: { query: string; suggestion: string };
    sorts: SortValue[];
    keywordRedirectUrl?: string;
    breadcrumbs: BreadcrumbResponse[];
}

export interface ContentSearchResponse {
    facets: FacetResponse[];
    breadcrumbs: BreadcrumbResponse[];
    freeTextSearch: string;
    pagination: PaginationType;
    results: ContentSearchResultEntry[];
    currentQuery: QueryValue;
    sorts: SortValue[];
}

export interface ContentSearchResultEntry {
    title: string;
    url: string;
    type: string;
    externalId: string;
    category: string;
}

export interface FacetResponse {
    code: string;
    multiSelect: boolean;
    name: string;
    priority: number;
    category: boolean;
    visible: boolean;
    values: FacetValueResponse[];
    userInputtedInterval?: boolean;
    valueFrom?: number;
    valueTo?: number;
}

export interface FacetValueResponse {
    code: string;
    count: number;
    name: string;
    selected: boolean;
    query: QueryValue;
}

export interface SearchResponse {
    contentSearchResult?: ContentSearchResponse;
    productSearchResult?: ProductSearchResponse;
}

export const search = catchUnauthorizedAndRetry(async (queryParams: URLSearchParams) => await api.get<SearchResponse>(searchURL(), queryParams));
export const searchAnonymously = async (queryString: string) => await api.getAnonymously<ProductSearchResponse>(productSearchURL(queryString));

export const productGuideSearch = catchUnauthorizedAndRetry(
    async (query = '', queryParams?: object) => await api.get<ProductSearchResponse>(productGuideURL(new URLSearchParams({ query, ...queryParams }))),
);
